module.exports = __webpack_public_path__ + "img/id.038cf34b.svg";